const publicUrl = process.env.PUBLIC_URL || "";

export const LOGO_PRIMARY = `${publicUrl}/assets/images/lgonew.png`;
export const LOGO_MICRO = `${publicUrl}/assets/images/micro.png`;
